export type MonthlyDataPoint = {
  name: string;
  [userName: string]: number | string;
};

export type UserMonthData = {
  name: string;
  value: number;
};

export type HistoricData = {
  Total: number;
  [userName: string]: number;
};

export type SummaryData = {
  historic: HistoricData;
  lastMonth: UserMonthData[];
};

export type ByUsersTable = {
  name: string;
  value: number;
};

export type TeamSummary = {
  graph: MonthlyDataPoint[];
  summary: SummaryData;
  last6Months: string[];
  byUsersTable: ByUsersTable[];
};

export const BASE_TEAM_SUMMARY: TeamSummary = {
  graph: [],
  summary: {
    historic: {
      Total: 0,
    },
    lastMonth: [],
  },
  last6Months: [],
  byUsersTable: [],
};
